import { useEffect, useMemo } from 'react';

import XCircleIcon from '~/components/atoms/Icons/XCircleIcon';

import styles from './FileImage.module.scss';

interface IFileImage {
  file: File;
  onClick: (file: File) => void;
}

export default function FileImage({ file, onClick }: IFileImage): JSX.Element {
  const src = useMemo(() => URL.createObjectURL(file), [file]);
  useEffect(() => {
    return () => {
      if (src) {
        URL.revokeObjectURL(src);
      }
    };
  }, [src]);

  return (
    <div className={styles.imageWrapper}>
      <img
        className={styles.image}
        key={src}
        alt=""
        src={src}
      />
      <XCircleIcon
        onClick={() => onClick(file)}
        background={false}
        className={styles.deleteIcon}
      />
    </div>
  );
}
